module.exports = __webpack_public_path__ + "img/logo_esign_white.b0e9e5ac.svg";